module.exports = __webpack_public_path__ + "static/media/dyno.d72a4763.svg";